export enum ColumnTypeEnum {
  input = 'input',
  text = 'text',
  money = 'money',
  calc = 'calc',
  number = 'number',
  toogle = 'toogle',
  select = 'select',
}
